"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_ATTRIBUTES_V1 = exports.EVENT_ATTRIBUTES = exports.EVENTS_V1 = exports.EVENTS = exports.MAX_BUCKET_SIZE = exports.FETCH_TIMEOUT = exports.SESSION_TIMEOUT = exports.SYNC_INTERVAL = exports.STORAGE_KEY = exports.AUTH_TOKEN = exports.ALLOWED_DOMAINS = exports.EVENTS_API_PATH = exports.TEST_ENV_API_URL = exports.API_URL = exports.isServer = exports.getTestEnvironmentName = void 0;
function getTestEnvironmentName() {
    // Do this intelligently
    const preCuemath = window.location.hostname.split('.cuemath.com')[0];
    const splits = preCuemath.split('.');
    return splits[splits.length - 1];
}
exports.getTestEnvironmentName = getTestEnvironmentName;
function isReactNative() {
    return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
}
function isServer() {
    return !(typeof window !== 'undefined' && window.document);
}
exports.isServer = isServer;
exports.API_URL = 'https://insightcollector.cuemath.com';
exports.TEST_ENV_API_URL = `https://insightcollector.${isReactNative() || isServer() ? 'k8stage' : getTestEnvironmentName()}.cuemath.com`;
exports.EVENTS_API_PATH = '/cueanalytics/v1/events';
exports.ALLOWED_DOMAINS = [
    'www.cuemath.com',
    'leap.cuemath.com',
    'leap-teacher.cuemath.com',
    'class.cuemath.com',
];
exports.AUTH_TOKEN = 'Basic YXdlc29tZWFuYWx5dGljczphd2Vzb21lYW5hbHl0aWNzcGFzc3dvcmQ=';
exports.STORAGE_KEY = 'CUEMATH_ANALYTICS';
exports.SYNC_INTERVAL = 30 * 1000;
exports.SESSION_TIMEOUT = isReactNative() ? 30 * 1000 : 30 * 60 * 1000;
exports.FETCH_TIMEOUT = 25 * 1000;
exports.MAX_BUCKET_SIZE = 10;
exports.EVENTS = {
    SCREEN_VIEW: 'Screen View',
    CLICK: 'Click',
};
exports.EVENTS_V1 = {
    SCREEN_VIEW: 'page_viewed',
    CLICK: 'clicked',
};
exports.EVENT_ATTRIBUTES = {
    SCREEN_NAME: 'Screen Name',
    CTA: 'CTA',
};
exports.EVENT_ATTRIBUTES_V1 = {
    SCREEN_NAME: 'page_name',
    CTA: 'cta',
};
//# sourceMappingURL=constants.js.map